module.exports = __webpack_public_path__ + "media/images/icons/illustration/mail-536ab61ff8982a2552658165d9e3eafa.svg";